import { useEffect } from "react";

import { useLaunchParams } from "@tma.js/sdk-react";
import { useEventCallback } from "usehooks-ts";

export const useWatchStartParam = (cb: (startParam: string) => void) => {
  const { tgWebAppStartParam } = useLaunchParams();
  const cbEvent = useEventCallback(cb);

  useEffect(() => {
    if (!tgWebAppStartParam) return;
    cbEvent(tgWebAppStartParam);
  }, [tgWebAppStartParam, cbEvent]);
};
